import { Button, Col, Layout, Row } from 'antd';
import { EmailInvitation, EmailInvitationStatus } from '../../modules/auth';

interface PartnerRegistrationResultComponentProps {
  emailInvitation?: EmailInvitation;
}
function PartnerRegistrationResultComponent({
  emailInvitation,
}: PartnerRegistrationResultComponentProps) {
  return (
    <>
      <Layout style={{ padding: '40px', background: '#fff' }}>
        <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
          <Col span={12}>
            <Row justify="center">
              <Col flex={1}>
                {!emailInvitation && (
                  <>
                    <Row justify="center">
                      <Col span={8}>
                        <h2>거래처 초대 요청이 삭제 되었습니다.</h2>
                      </Col>
                    </Row>
                    <Row justify="center">
                      <Col span={8}>
                        <Button href="/login" style={{ width: '100%' }}>
                          로그인 페이지로 이동
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
                {emailInvitation &&
                  emailInvitation.status !== EmailInvitationStatus.INVITED && (
                    <Row justify="center">
                      <Col span={8}>
                        <h3>
                          협력업체 등록을
                          {emailInvitation.status ===
                          EmailInvitationStatus.ACCEPTED
                            ? ' 수락 '
                            : ' 거절 '}
                          하셨습니다.
                        </h3>
                      </Col>
                    </Row>
                  )}
                {emailInvitation &&
                  emailInvitation.status !== EmailInvitationStatus.INVITED && (
                    <Row justify="center">
                      <Col span={8}>
                        <Button href="/login" style={{ width: '100%' }}>
                          로그인 페이지로 이동
                        </Button>
                      </Col>
                    </Row>
                  )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    </>
  );
}

export default PartnerRegistrationResultComponent;
